import { I18n } from '@app/i18n/strings-keys';
import { HAWKER_SESSION_STATUS_VALUE } from '../types/entities/hawker-session/hawker-session-status.enum';
import { COMMON_STATUS } from '../types/enums/common-status.enum';
import { ORDER_STATUS_VALUE } from '../types/enums/order-status.enum';
import { STAND_WORKSHEET_STATUS_VALUE } from '../types/enums/stand-worksheet-status.enum';
import { TRANSFER_STATUS_VALUE } from '../types/enums/transfer-status.enum';

const COMMON_STATUS_MAPPING: Record<string, string> = {
  [COMMON_STATUS.CREATED]: I18n.Common.Created,
  [COMMON_STATUS.LAST_UPDATED]: I18n.Common.LastUpdated,
};

const ORDER_OPERATION_STATUS_MAPPING: Record<string, string> = {
  ...COMMON_STATUS_MAPPING,
  [ORDER_STATUS_VALUE.Pending]: I18n.Status.Submitted,
  [ORDER_STATUS_VALUE.Rejected]: I18n.Status.Rejected,
  [ORDER_STATUS_VALUE.Completed]: I18n.Status.Accepted,
  [ORDER_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
};

const TRANSFER_OPERATION_STATUS_MAPPING: Record<string, string> = {
  ...COMMON_STATUS_MAPPING,
  [TRANSFER_STATUS_VALUE.Pending]: I18n.Status.Submitted,
  [TRANSFER_STATUS_VALUE.Rejected]: I18n.Status.Rejected,
  [TRANSFER_STATUS_VALUE.Completed]: I18n.Status.Accepted,
  [TRANSFER_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
  [TRANSFER_STATUS_VALUE.Void]: I18n.Status.Voided,
};

const TRANSFER_OPERATION_LOWER_STATUS_MAPPING: Record<string, string> = {
  [COMMON_STATUS.CREATED]: I18n.Common.created,
  [COMMON_STATUS.LAST_UPDATED]: I18n.Common.lastUpdated,
  [TRANSFER_STATUS_VALUE.Pending]: I18n.Status.submitted,
  [TRANSFER_STATUS_VALUE.Rejected]: I18n.Status.rejected,
  [TRANSFER_STATUS_VALUE.Completed]: I18n.Status.accepted,
  [TRANSFER_STATUS_VALUE.Canceled]: I18n.Status.canceled,
  [TRANSFER_STATUS_VALUE.Void]: I18n.Status.voided,
};

const STAND_WORKSHEET_STATUS_MAPPING: Record<string, string> = {
  ...COMMON_STATUS_MAPPING,
  [STAND_WORKSHEET_STATUS_VALUE.Open]: I18n.Status.Opened,
  [STAND_WORKSHEET_STATUS_VALUE.Approved]: I18n.Status.Approved,
  [STAND_WORKSHEET_STATUS_VALUE.Completed]: I18n.Status.Completed,
  [STAND_WORKSHEET_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
};

const HAWKER_SESSION_OPERATION_STATUS_MAPPING: Record<string, string> = {
  ...COMMON_STATUS_MAPPING,
  [HAWKER_SESSION_STATUS_VALUE.Canceled]: I18n.Status.Canceled,
  [HAWKER_SESSION_STATUS_VALUE.Closed]: I18n.Status.Closed,
};

export {
  COMMON_STATUS_MAPPING,
  ORDER_OPERATION_STATUS_MAPPING,
  TRANSFER_OPERATION_STATUS_MAPPING,
  TRANSFER_OPERATION_LOWER_STATUS_MAPPING,
  STAND_WORKSHEET_STATUS_MAPPING,
  HAWKER_SESSION_OPERATION_STATUS_MAPPING,
};
